import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { I18nProvider } from "./context/I18nContext";
import Home from "./pages/Home";
import ApartmentDetail from "./pages/ApartmentDetail";
import SeoLanding from "./pages/SeoLanding";
import { SEO_PAGE_SLUGS } from "./data/seoPages";
import { PaymentSuccess, PaymentCancel } from "./pages/Payment";
import BlogList from "./pages/BlogList";
import BlogPost from "./pages/BlogPost";
import NotFound from "./pages/NotFound";
import ApartmentRedirect from "./pages/ApartmentRedirect";
import QuickContact from "./components/QuickContact";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import CookieConsent from "./components/CookieConsent";
import LegalPage from "./pages/LegalPage";
import { LEGAL_SLUGS } from "./data/legalPages";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    function loop(time) {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    }
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <I18nProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/appartamenti/:localita/:slug" element={<ApartmentDetail />} />
            <Route path="/appartamento/:id" element={<ApartmentRedirect />} />
            <Route path="/guide" element={<BlogList />} />
            <Route path="/guide/:slug" element={<BlogPost />} />
            {SEO_PAGE_SLUGS.map((slug) => (
              <Route key={slug} path={`/${slug}`} element={<SeoLanding slug={slug} />} />
            ))}
            {LEGAL_SLUGS.map((slug) => (
              <Route key={slug} path={`/${slug}`} element={<LegalPage slug={slug} />} />
            ))}
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/*" element={<AdminLayout />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <QuickContact />
          <CookieConsent />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
        </I18nProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
